/**
 * Offline cache adapter for user preferences.
 * Supabase profiles.preferences is the source of truth when online.
 */

import {
  DEFAULT_USER_PREFERENCES,
  mergeUserPreferences,
} from "./userPreferences";

const STORAGE_KEY = "CP_USER_PREFERENCES_V1";
const USER_ID_SEP = "::";

export function buildUserPreferencesCacheKey(userId) {
  if (!userId) {
    return STORAGE_KEY;
  }
  return `${STORAGE_KEY}${USER_ID_SEP}${userId}`;
}

export function resolveUserPreferencesCacheId(actor) {
  if (!actor) {
    return null;
  }

  if (actor.isGuest) {
    return "guest";
  }

  return actor.profile_id || actor.supabase_user_id || null;
}

export function loadCachedUserPreferences(userId = null) {
  try {
    const key = buildUserPreferencesCacheKey(userId);
    const raw = localStorage.getItem(key);
    if (!raw) {
      if (userId) {
        const legacy = localStorage.getItem(STORAGE_KEY);
        if (legacy) {
          return mergeUserPreferences(DEFAULT_USER_PREFERENCES, JSON.parse(legacy));
        }
      }
      return { ...DEFAULT_USER_PREFERENCES };
    }
    return mergeUserPreferences(DEFAULT_USER_PREFERENCES, JSON.parse(raw));
  } catch {
    return { ...DEFAULT_USER_PREFERENCES };
  }
}

export function persistCachedUserPreferences(preferences, userId = null) {
  try {
    const key = buildUserPreferencesCacheKey(userId);
    localStorage.setItem(key, JSON.stringify(preferences));
  } catch (err) {
    console.warn("[userPreferencesBridge] cache persist failed", err);
  }
}
